import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import { tienFormat } from "../utils/NumberUtils";
import './one789.scss';
import { One789BetTypes, TicketPlay } from "./oneTypes";

type OwnProps = {
    data?: TicketPlay,
    priceMap?: Map<number, Map<string, number>>;
}

const OneBetNumGrid: FC<OwnProps> = ({
    data,
    priceMap,
}) => {
    function isHasExtra(number: string, betType: One789BetTypes): boolean {
        if (priceMap) {
            const byBetType = priceMap.get(betType);
            if (byBetType) {
                const found = byBetType.get(number);
                if (found) {
                    return true;
                }
            }
        }
        return false;
    }
    const [state, setState] = useState({
        tongDiem: 0,
        tongTien: 0,
    })
    function renderTickets() {
        const tsx = [];
        if (data?.Tickets) {
            let tongDiem = 0;
            let tongTien = 0;
            for (let item of data.Tickets) {
                if (item.Items) {
                    for (let ticketItem of item.Items) {
                        const it = <div className="one-grid-item">
                            <div className="one-betNum">{ticketItem.Numbers.join(',')}</div>
                            <div className="one-point">{tienFormat(ticketItem.Point)}</div>
                            <div className={isHasExtra(ticketItem.Numbers.join(','), item.BetType) ? 'one-price has-extra' : "one-price"}>{ticketItem.Price}</div>
                        </div>
                        tsx.push(it)
                        tongDiem += ticketItem.Point
                        tongTien += ticketItem.Point * ticketItem.Price
                    }
                }
            }
            setState(prev => ({ ...prev, tongDiem: tongDiem, tongTien: tongTien }))
        }
        return tsx;
    }
    return (<div className="one-betnum-container">
        <div> tổng điểm {tienFormat(state.tongDiem)} = {tienFormat(state.tongTien)} </div>
        <div className="one-grid-container">

            {renderTickets()}
        </div>
    </div>)
}

export default memo(OneBetNumGrid);